import { createRoute } from '@tanstack/react-router';

import { AdminBaseRouteLayout } from '$/routes/Admin/AdminBaseRouteLayout';

export const AdminUserManagementRoute = createRoute({
  getParentRoute: () => AdminBaseRouteLayout,
  path: '/admin/user-management',
}).lazy(() => import('./AdminUserManagementRoute.lazy').then((d) => d.Route));
